/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import { SplitButton } from 'primereact/splitbutton';

import FileInput from '@components/FileInput';
import JustificationModal from '@components/JustificationModal';

import { validatePermissionAction } from '@actions/sessionPermission';

import { SET_VALUES_DOCUMENT } from '@constants/actionType';
import { LANGUAGE_DEFAULT, AuthorizedStatus } from '@constants/general';
import catalogPermissionsId from '@constants/catalogPermissionsId'


import store from '@store';

class ContentDocumentsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      url: '',
      target: '_blank',
      languageLabel: [],
      errors: [],
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    }
    this.initialValuesForm = {
      file: []
    };

    this.actions = [
      {
        label: this.props.t('Cancelar'),
        command: (e) => {}
      }
    ]
  }

  componentDidMount() {
    const { keysLenguages, _content, itemsTabsLenguages, t } = this.props;
    if (_content?.document) {
      this.setState({
        ..._content.document
      });
    } else {
      keysLenguages.map((item) =>
        this.setState({ [item]: { ...this.initialValuesForm } })
      );
    }

    const languageLabel = itemsTabsLenguages.map((item) => {
      const label = item.label.replace(`(${t('Obligatorio')})`, '')
      return label
    })
    this.setState({ languageLabel })
    this.validateOptionsSlit()
    this.setState({ loadingPage: false });
  }

  validateOptionsSlit = () => {
    const { isEdit, validatePermissionAction, estatus } = this.props
    if (isEdit) {
      // @Editar doc
      if (estatus !== AuthorizedStatus.STATUS_AUTHORIZED) {
        const canDeleteVersion = validatePermissionAction(catalogPermissionsId.ELIMINAR_DOCUMENTO)
        if (canDeleteVersion) {
          this.actions.unshift({
            label: this.props.t('Eliminar Version'),
            icon: 'pi pi-times',
            command: () => {
              this.props.deleteVersion()
            }
          })
        }
        const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_PUBLICACION_DE_DOCUMENTOS)
        if (hasAuthorized) {
          if (estatus !== AuthorizedStatus.STATUS_REJECTED) {
            this.actions.unshift({
              label: this.props.t('Rechazar'),
              icon: 'pi pi-exclamation-triangle',
              command: () => {
                this.props.reject()
              }
            })
          }
          this.actions.unshift({
            label: this.props.t('Autorizar'),
            icon: 'pi pi-check-circle',
            command: () => {
              this.onSubmit((justification) =>  this.props.authorize(justification))
            }
          })
        } else {
          if (estatus !== AuthorizedStatus.STATUS_PENDING) {
            this.actions.unshift({
              label: this.props.t('Enviar a autorizar'),
              icon: 'pi pi-envelope',
              command: () => {
                this.onSubmit((justification) =>  this.props.sendAuthorize(justification))

              }
            })
          }
        }
      }
    } else {
      // @Nueva doc
      const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_PUBLICACION_DE_DOCUMENTOS)
      if (hasAuthorized) {
        this.actions.unshift({
          label: this.props.t('Autorizar'),
          icon: 'pi pi-check-circle',
          command: () => {
            this.onSubmit((justification) =>  this.props.authorize(justification))
          }
        })
      } else {
        this.actions.unshift({
          label: this.props.t('Enviar a autorizar'),
          icon: 'pi pi-envelope',
          command: () => {
            this.onSubmit((justification) =>  this.props.sendAuthorize(justification))
          }
        })
      }
    }
  }

  onChangeSimple = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  uploadFileDynamic = (files, isImage, language) => {
    const [file] = files;
    const { name: fileName } = file;
    const localUrl = URL.createObjectURL(file);
    const fileExtension = fileName.split('.').pop();
    const data = {
      fileName,
      currentValue: localUrl,
      file,
      fileExtension,
      isImage,
    };
    this.setState((prevState) => ({
      [language]: { ...prevState[language], file: [data] },
    }), () => this.validateFieldsOnchange(`${language}-file`, data));
  };

  removeFileDinamyc = (language) => {
    this.setState((prevState) => ({
      [language]: { ...prevState[language], file: [] },
    }))
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { t, isEdit } = this.props
    const { file } = this.state[LANGUAGE_DEFAULT]
    let errors = {}
    if (!file.length && !isEdit) errors = { ...errors, [`${LANGUAGE_DEFAULT}-file`]: `${t('Archivo')} ${t('es requerido')}` }
    this.setState({errors})
    return errors
  }

  // onSubmit = async (e) => {
  //   e.preventDefault();
  //   const validate = await this.validateFields()
  //   if (some(validate, {})) return true
  //   const { success } = this.props;
  //   await this.setValuesToStateGlobal();
  //   return success();
  // };

  onSubmit = async (onAction) => {
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    const { t, success } = this.props;
    await this.setValuesToStateGlobal();
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => onAction(justification),
      },
    });
  };

  setValuesToStateGlobal = async () => {
    const { keysLenguages } = this.props;
    const getValues = keysLenguages.reduce((accum, item) => {
      accum[item] = this.state[item];
      return accum;
    }, {});
    await store.dispatch({
      type: SET_VALUES_DOCUMENT,
      payload: { content: {
        document: getValues
      }},
    });
    return true
  };

  render() {
    const { t, btnSubmitLoading, onBack, success } = this.props;
    const { url, target, loadingPage, errors, showModalJustification } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderFilesByLanguage = () => {
      const { languageLabel } = this.state
      const { keysLenguages } = this.props
      return languageLabel.map((language, index) => {
        const  prefixLenguage = keysLenguages[index]
        return (
          <div className="p-col-12 p-md-6 p-lg-6" key={prefixLenguage}>
            <label className="p-text-bold p-pb-2">{language}</label>
            <FileInput
              onChangeFile={(files, isImage) => this.uploadFileDynamic(files, isImage, prefixLenguage)}
              files={this.state[prefixLenguage].file}
              removeAllFiles={() => this.removeFileDinamyc(prefixLenguage)}
              removeFile={() => this.removeFileDinamyc(prefixLenguage)}
              accept="application/pdf"
              txtDrop={t('Arrastra y suelta el archivo', {lng: prefixLenguage })}
              classNameBorderMain={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-file`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-file`)}
          </div>
        )})
    };

    if (loadingPage) return true;
    return (
      <>
        {/* <form onSubmit={this.onSubmit} autoComplete="false"> */}
        <div>
          <div className="p-fluid p-grid p-mb-4">
            {renderFilesByLanguage()}
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              {/* <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              /> */}
              <SplitButton label={t('Guardar')} icon="pi pi-save" onClick={() => this.onSubmit((justification) => success(justification))} model={this.actions}/>
            </div>
          </div>
        </div>
        {/* </form> */}
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.setState({showModalJustification: { isVisible: false }})}
          onContinueAction={showModalJustification.continueAction}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _content: state.document.content,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  estatus: state.document.estatus
});

const mapDispatchToProps = {
  validatePermissionAction
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ContentDocumentsForm);
